import React from 'react';
import { motion } from 'framer-motion';
import IPadMockup from './IPadMockup';

const customEase = [0.16, 1, 0.3, 1];

export default function Hero() {
  return (
    <main className="flex-1 flex flex-col">
      {/* Block 2: The Hero Area */}
      <section className="flex flex-col items-center text-center pt-32 sm:pt-40 md:pt-48 pb-12 px-4 sm:px-6 max-w-4xl mx-auto w-full">
        
        <motion.h1 
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.4, ease: customEase }}
          className="text-[#FFFFFF] font-semibold text-4xl sm:text-5xl md:text-[56px] leading-[1.1] tracking-[-0.5px] mb-6 will-change-[transform,opacity]"
        >
          Pacing for the recording room.
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.4, ease: customEase }}
          className="text-[#D4D4D8] font-normal text-lg sm:text-[19px] leading-[1.6] max-w-2xl mb-12 will-change-[transform,opacity]"
        >
          Run a clean countdown on any tablet. Keep your talent focused, your schedule locked, and your sessions wrapping exactly on the minute. Zero noise.
        </motion.p>
        
        {/* The Grid Actions */}
        <motion.div 
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.4, ease: customEase }}
          className="flex items-center justify-center w-full will-change-[transform,opacity]"
        >
          <a 
            href="https://web.studiotimer.app/#/signup"
            className="w-full sm:w-auto bg-[#FFFFFF] text-[#0D0D0D] font-semibold text-[15px] py-3.5 px-8 rounded-[6px] hover:bg-gray-200 transition-all duration-200 ease-apple hover:scale-[1.02] active:scale-[0.98] text-center block sm:inline-block will-change-transform"
          >
            Create account
          </a>
        </motion.div>

      </section>

      {/* iPad Media Container */}
      <motion.div
        initial={{ opacity: 0, scale: 0.98 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.35, duration: 0.4, ease: customEase }}
        className="w-full will-change-[transform,opacity]"
      >
        <IPadMockup />
      </motion.div>
    </main>
  );
}